import React from 'react';
import { connect } from 'react-redux';
import { Icon } from '@treelab/panda';

import { IRootState } from '../../../../modules/stores';
import { GLYPHS } from '../../../../constants/icons';
import { COLORS } from '../../../../constants/colors';

import { Container } from './styled';
import { isAbsentCellValue } from '../../../../helpers';

type IConnectProps = ReturnType<typeof mapState>;
interface IProps {
  fieldId: string;
  recordId?: string;
}

const WithFieldId: React.FC<IProps & IConnectProps> = ({ cell }) => {
  if (isAbsentCellValue(cell)) return null;
  // @TODO checkbox does not render empty boxes
  if (cell === false) return null;

  return <Raw />;
};

/** Value arrives as [true, true, true] */
const MultiRaw: React.FC<{ value: boolean[] }> = ({ value }) => (
  <Container>
    {(value || []).map((isChecked: boolean, index: number) =>
      isChecked ? <Raw key={index} /> : null,
    )}
  </Container>
);

const Raw: React.FC = () => (
  <Icon size={{ width: 14, height: 14 }} icon={GLYPHS.CHECKBOX} style={{ color: COLORS.blue }} />
);

const mapState = ({ core }: IRootState, { fieldId, recordId }: IProps) => ({
  cell: core.recordById[recordId || core.currentRecordId]?.cells[fieldId],
});

export default {
  WithFieldId: connect(mapState)(WithFieldId),
  MultiRaw: MultiRaw,
};
